import React from 'react';

const NotResponsibleItem = ({ title, description }) => {
  return (
    <div className="flex items-start">
      <span className="text-red-500 mr-3 text-xl">✗</span>
      <div>
        <p className="text-gray-900 font-semibold">{title}</p>
        <p className="text-gray-600 text-sm">{description}</p>
      </div>
    </div>
  );
};

export default NotResponsibleItem;
